export const UserStatus = {
  NEWTEACHER: "newteacher",
  ADDED_FIRST_CLASS: "added_first_class",
  WAITINGFORAPPROVAL: "waitingforapproval",
  APPROVED: "approved"
};
